export const getEntitySystemsByCompanyNameQuery = (companyName: string) => {
    return `
    {
      entitySystemsByCompanyName(companyName:"${companyName}"){
        id
        hasEtlCustomization
        entity{
          id
          name
        }
        system{
          id
          name
        }
        createdAt
        updatedAt
        integrationType
        isRequiredDaily
        isGenerateIpe
        forceGenerate
      }
    }
    `
}
